// @flow
import React, { useState } from 'react';

// Material
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import EconomySeatIcon from '@material-ui/icons/BusinessCenterTwoTone';
import FirstClassSeatIcon from '@material-ui/icons/MonetizationOnTwoTone';
import Grid from '@material-ui/core/Grid';

// Custom
import { FormGroup } from '../../forms/FormGroup';
import CustomSelect from '../../forms/CustomSelect';
import PricingCard from './PricingCard';
import { Message, SectionSubTitle, SectionCopy } from '../../text';
import { ContentWithPadding, SectionBlock } from '../../layout';
import {
  mapStationToOrdinaryCarsPricing,
  mapStationToGreenCarsPricing,
} from '../../helpers';

// Data
import { economySeatBenefits, firstClassSeatBenefits } from './constants';
import { ticketTypeOptions, pricingTableOptions } from '../../../data/options';

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '48px',
  },
}));

const PricingBlock = () => {
  const classes = useStyles();
  const [station, setStation] = useState('tokyo');
  const [ticketType, setTicketType] = useState('one_way');
  const isRoundTrip = ticketType === 'round_trip';

  const handleStationChange = (e: any) => {
    setStation(e.target.value);
  };

  const handleTicketTypeChange = (e: any) => {
    setTicketType(e.target.value);
  };

  return (
    <SectionBlock>
      <ContentWithPadding py="30">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <SectionSubTitle>
              Ticket <b>Prices</b>
            </SectionSubTitle>
            <SectionCopy mb={32}>
              Choose from first class or economy seating. Purchasing round-trip
              tickets can lead to huge savings! Try the pricing simulator to see
              for yourself.
            </SectionCopy>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormGroup>
                  <CustomSelect
                    label="Where to?"
                    defaultValue={station}
                    options={pricingTableOptions}
                    onChange={handleStationChange}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6}>
                <FormGroup>
                  <CustomSelect
                    label="Ticket type?"
                    defaultValue={ticketType}
                    options={ticketTypeOptions}
                    onChange={handleTicketTypeChange}
                  />
                </FormGroup>
              </Grid>
            </Grid>
            <Collapse in={isRoundTrip} unmountOnExit>
              <Message
                color="var(--color-system-success)"
                style={{ textAlign: 'left', fontWeight: 'bold' }}
              >
                Travel for a flat rate of ¥4,000 with round trip economy
                tickets!
              </Message>
            </Collapse>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <PricingCard
                  station={station.toUpperCase()}
                  ticketType={ticketType}
                  label="Economy"
                  price={mapStationToOrdinaryCarsPricing(station, ticketType)}
                  benefits={economySeatBenefits}
                  renderIcon={() => (
                    <EconomySeatIcon className={classes.icon} color="primary" />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <PricingCard
                  station={station.toUpperCase()}
                  ticketType={ticketType}
                  label="First-Class"
                  price={mapStationToGreenCarsPricing(station, ticketType)}
                  benefits={firstClassSeatBenefits}
                  renderIcon={() => (
                    <FirstClassSeatIcon
                      className={classes.icon}
                      color="primary"
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ContentWithPadding>
    </SectionBlock>
  );
};

export default PricingBlock;
